<script>
    import StepsProgressBar from '../common/sidebar/StepsProgressBar.svelte'
    import AppComponent from '../common/AppComponent.svelte'
    import QuotePage from "./QuotePage.svelte"
</script>

<StepsProgressBar currentPage={5}/>
<AppComponent previousPage="#/summary" nextPage="#/download">
    <QuotePage/>
</AppComponent>
